module.exports = __webpack_public_path__ + "img/f_6.f98c316d.png";